var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("second-nav-bar"),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "info-container" },
          [
            _c(
              "el-form",
              { ref: "form", attrs: { rules: _vm.rules, model: _vm.form } },
              [
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-left": "0", "margin-right": "0" },
                    attrs: { gutter: 24, type: "flex", justify: "end" }
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-row",
                          {
                            attrs: { gutter: 24, type: "flex", align: "middle" }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 6 }
                              },
                              [_vm._v("\n                校长\n              ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 9 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "teacherName" } },
                                  [
                                    _vm.editing
                                      ? _c("el-input", {
                                          attrs: {
                                            maxlength: 20,
                                            placeholder: "请输入姓名"
                                          },
                                          model: {
                                            value: _vm.form.teacherName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "teacherName",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "form.teacherName"
                                          }
                                        })
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "info-span",
                                            attrs: {
                                              title: _vm.form.teacherName
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.form.teacherName || "-"
                                              )
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 9 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "teacherNum" } },
                                  [
                                    _vm.editing
                                      ? _c("el-input", {
                                          attrs: {
                                            maxlength: 20,
                                            placeholder: "请输入手机号"
                                          },
                                          model: {
                                            value: _vm.form.teacherNum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "teacherNum",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "form.teacherNum"
                                          }
                                        })
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "info-span",
                                            attrs: {
                                              title: _vm.form.teacherNum
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.form.teacherNum || "-")
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-row",
                          {
                            attrs: { gutter: 24, type: "flex", align: "middle" }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 6 }
                              },
                              [
                                _vm._v(
                                  "\n                网管员\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 9 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "netAdminName" } },
                                  [
                                    _vm.editing
                                      ? _c("el-input", {
                                          attrs: {
                                            maxlength: 20,
                                            placeholder: "请输入姓名"
                                          },
                                          model: {
                                            value: _vm.form.netAdminName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "netAdminName",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "form.netAdminName"
                                          }
                                        })
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "info-span",
                                            attrs: {
                                              title: _vm.form.netAdminName
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.form.netAdminName || "-"
                                              )
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 9 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "netAdminNum" } },
                                  [
                                    _vm.editing
                                      ? _c("el-input", {
                                          attrs: {
                                            maxlength: 20,
                                            placeholder: "请输入手机号"
                                          },
                                          model: {
                                            value: _vm.form.netAdminNum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "netAdminNum",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "form.netAdminNum"
                                          }
                                        })
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "info-span",
                                            attrs: {
                                              title: _vm.form.netAdminNum
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.form.netAdminNum || "-"
                                              )
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        !_vm.editing
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "medium" },
                                on: { click: _vm.editInfo }
                              },
                              [_vm._v("编辑")]
                            )
                          : [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "medium",
                                    plain: ""
                                  },
                                  on: { click: _vm.cacelEdit }
                                },
                                [_vm._v("取消")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "danger",
                                  attrs: { type: "primary", size: "medium" },
                                  on: { click: _vm.confirmEdit }
                                },
                                [_vm._v("确定")]
                              )
                            ]
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-row",
              {
                staticClass: "search-row",
                staticStyle: { "margin-left": "0", "margin-right": "0" },
                attrs: { gutter: 24 }
              },
              [
                _c(
                  "el-col",
                  { attrs: { span: 5 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "年级", clearable: "" },
                        on: { change: _vm.changeGrade },
                        model: {
                          value: _vm.grade,
                          callback: function($$v) {
                            _vm.grade = $$v
                          },
                          expression: "grade"
                        }
                      },
                      _vm._l(_vm.schoolGradeOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.name, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 5 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "班级", clearable: "" },
                        model: {
                          value: _vm.classId,
                          callback: function($$v) {
                            _vm.classId = $$v
                          },
                          expression: "classId"
                        }
                      },
                      _vm._l(_vm.classes, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.name, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 5 } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "姓名", clearable: "" },
                      model: {
                        value: _vm.name,
                        callback: function($$v) {
                          _vm.name = typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticStyle: { "text-align": "center" },
                    attrs: { span: 4 }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "medium" },
                        on: {
                          click: function($event) {
                            return _vm.initTable(1)
                          }
                        }
                      },
                      [_vm._v("查询")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-container scroll" },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "", size: "medium" },
                        on: { click: _vm.handleImport }
                      },
                      [_vm._v("导入")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "danger",
                        attrs: { type: "primary", plain: "", size: "medium" },
                        on: { click: _vm.handleExport }
                      },
                      [_vm._v("导出未完成名单")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticClass: "table" },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.pageData.t1,
                          size: "medium",
                          "row-class-name": _vm.isRowAailable
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "regionName",
                            "min-width": "60",
                            label: "区县"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "schoolName",
                            "min-width": "120",
                            label: "学校"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            "min-width": "60",
                            label: "姓名"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "gender",
                            "min-width": "50",
                            label: "性别"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "certificate",
                            "min-width": "80",
                            label: "证件类型"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "certificateNo",
                            "min-width": "150",
                            label: "证件号码"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "grade",
                            "min-width": "60",
                            label: "年级"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "className",
                            "min-width": "80",
                            label: "班级"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "heath",
                            "min-width": "70",
                            label: "健康状况"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: { prop: "healthStatus", label: "当前户籍" }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "preSchoolDomicileProvince",
                                "min-width": "60",
                                label: "省"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "preSchoolDomicileCity",
                                "min-width": "60",
                                label: "市"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "preSchoolDomicileCounty",
                                "min-width": "60",
                                label: "区县"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "preSchoolDetailAddress",
                                label: "详细地址",
                                "min-width": "100"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "address-ellipsis",
                                          attrs: {
                                            title:
                                              scope.row.preSchoolDetailAddress
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.preSchoolDetailAddress
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: { prop: "healthStatus", label: "当前居住地" }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "currentDomicileProvince",
                                "min-width": "60",
                                label: "省"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "currentDomicileCity",
                                "min-width": "60",
                                label: "市"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "currentDomicileCounty",
                                "min-width": "60",
                                label: "区县"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "currentDomicileAddress",
                                label: "详细地址",
                                "min-width": "100"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "address-ellipsis",
                                          attrs: {
                                            title:
                                              scope.row.currentDomicileAddress
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.currentDomicileAddress
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "classTeacherName",
                            "min-width": "80",
                            label: "班主任姓名"
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "classTeacherPhone",
                            "min-width": "100",
                            label: "班主任电话"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticClass: "zyyj-pagination-row" },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        total: _vm.pageData.t2,
                        "current-page": _vm.page,
                        "page-sizes": [20, 50, 100],
                        "page-size": _vm.size,
                        background: "",
                        layout: "total, sizes, prev, pager, next"
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.page = $event
                        },
                        "update:current-page": function($event) {
                          _vm.page = $event
                        },
                        "update:pageSize": function($event) {
                          _vm.size = $event
                        },
                        "update:page-size": function($event) {
                          _vm.size = $event
                        },
                        "current-change": _vm.initTable,
                        "size-change": _vm.handleSizeChange
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "excel-importer-box",
        {
          attrs: {
            topic: "人",
            action: "/acc/students/outer-info/import",
            template: "/acc/students/outer-info/templates",
            errorUrl: "/acc/students/outer-info/fail/export",
            type: "户籍信息",
            visible: _vm.importDialogVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.importDialogVisible = $event
            },
            "import-result": function($event) {
              return _vm.initTable(_vm.page)
            }
          }
        },
        [
          _c(
            "template",
            { slot: "if-failure" },
            [
              _c("el-table-column", {
                attrs: { prop: "objectName", label: "学生姓名", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "rowNum", label: "所在行", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "errorMessageList", label: "导入失败原因" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return _vm._l(scope.row.errorMessageList, function(
                        msg,
                        index
                      ) {
                        return _c("span", { key: msg }, [
                          _c("span", [_vm._v(_vm._s(msg))]),
                          _vm._v(" "),
                          index !== scope.row.errorMessageList.length - 1
                            ? _c("span", [_vm._v("、")])
                            : _vm._e()
                        ])
                      })
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("校务管理 / 户籍信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-f92bc57e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-f92bc57e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/school-admin/affair/OuterInfoManage.vue
// module id = null
// module chunks = 